import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

export default function initFancybox() {
	bindDefaultFancyboxInstances();
	bindTriggerElementsToFancybox();
}

function bindDefaultFancyboxInstances() {
	Fancybox.bind( '[data-fancybox]', {} );
}

function bindTriggerElementsToFancybox() {
	const triggerElement = document.querySelector( '.fancybox-trigger' );
	if ( ! triggerElement ) {
		return;
	}
	const { target } = triggerElement.dataset;

	triggerElement.addEventListener( 'click', () => {
		Fancybox.fromNodes(
			Array.from( document.querySelectorAll( `[data-fancybox="${target}"]` ) ),
		);
	} );
}

$('[data-fancybox="gallery"]').each(function () {
	var $j = jQuery.noConflict();
	$j('.fancy-number').text($("[data-fancybox='gallery']").length);
});

    // Remove previous bindings to avoid conflicts
    Fancybox.destroy();

    // Basic gallery initialization
    Fancybox.bind('[data-fancybox="gallery"]', {});

    // Video gallery initialization
    Fancybox.bind('[data-fancybox="video-gallery"]', {
        type: 'video',
        videoAutoplay: true,
        on: {
            closing: (fancybox, slide) => {
                // Ensure video stops playing when modal closes
                const video = slide.$content.querySelector('video');
                if (video) {
                    video.pause();
                    video.currentTime = 0;
                }
            }
        }
    });

